import {
  convertToAmPm,
  getProfileStatus,
  PROFILE_STATUS,
} from "../utils/timeUtils";
import bubbleStyles from "../styles/Bubbles.module.css";

function ProfileStatus({ profile }) {
  const status = getProfileStatus(profile);

  const bubbleClass =
    status === PROFILE_STATUS.VACATION
      ? bubbleStyles.vacation
      : status === PROFILE_STATUS.OPEN
        ? bubbleStyles.open
        : bubbleStyles.closed;

  const label =
    status === PROFILE_STATUS.VACATION
      ? "On Vacation 🏖️"
      : status === PROFILE_STATUS.OPEN
        ? "Open Now 🌹"
        : status === PROFILE_STATUS.COMING_SOON
          ? "Coming Soon 🤩"
          : "Sleeping 🌙";

  return (
    <div>
      <div className={`${bubbleStyles.bubbleStyle} ${bubbleClass}`}>
        {label}
      </div>

      <p>
        <strong>Work Hours:</strong> {convertToAmPm(profile.startTime)} –{" "}
        {convertToAmPm(profile.endTime)}
      </p>
    </div>
  );
}

export default ProfileStatus;
